import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import { UserBasicInfoFragmentDoc } from '../../screens/communities/components/GroupMembersList/__generated__/user.fragment.generated';
import { MediaFileFragmentDoc } from './file.generated';
export type PostCommentFragment = { __typename?: 'Comment', id: string, content: string, updatedAt: number, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }, likes?: Array<{ __typename?: 'CommentLike', id: string, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null };

export type PostDataFragment = { __typename?: 'Post', id: string, uuid: string, type: Types.PostType, pinned: boolean, status: string, content?: string | null, createdAt: number, updatedAt: number, publishedAt?: number | null, informationFeedId?: string | null, communityGroupId?: string | null, selectedUsers?: Array<{ __typename?: 'PostAccess', user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, mediaFiles: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }>, author?: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } | null };

export type PostLikeFragment = { __typename?: 'PostLike', id: string, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } };

export type PostWithCommentsAndLikesFragment = { __typename?: 'Post', id: string, uuid: string, type: Types.PostType, pinned: boolean, status: string, content?: string | null, createdAt: number, updatedAt: number, publishedAt?: number | null, informationFeedId?: string | null, communityGroupId?: string | null, likes?: Array<{ __typename?: 'PostLike', id: string, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: number, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }, likes?: Array<{ __typename?: 'CommentLike', id: string, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null }>, selectedUsers?: Array<{ __typename?: 'PostAccess', user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, mediaFiles: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }>, author?: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } | null };

export const PostDataFragmentDoc = gql`
    fragment PostData on Post {
  id
  uuid
  type
  pinned
  status
  content
  createdAt
  updatedAt
  publishedAt
  informationFeedId
  communityGroupId
  selectedUsers {
    user {
      ...UserBasicInfo
    }
  }
  mediaFiles {
    ...MediaFile
  }
  author {
    ...UserBasicInfo
  }
}
    ${UserBasicInfoFragmentDoc}
${MediaFileFragmentDoc}`;
export const PostLikeFragmentDoc = gql`
    fragment PostLike on PostLike {
  id
  author {
    ...UserBasicInfo
  }
}
    ${UserBasicInfoFragmentDoc}`;
export const PostCommentFragmentDoc = gql`
    fragment PostComment on Comment {
  id
  content
  updatedAt
  author {
    id
    ...UserBasicInfo
  }
  likes {
    id
    author {
      ...UserBasicInfo
    }
  }
}
    ${UserBasicInfoFragmentDoc}`;
export const PostWithCommentsAndLikesFragmentDoc = gql`
    fragment PostWithCommentsAndLikes on Post {
  ...PostData
  likes {
    ...PostLike
  }
  comments {
    ...PostComment
  }
}
    ${PostDataFragmentDoc}
${PostLikeFragmentDoc}
${PostCommentFragmentDoc}`;